var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomerServices.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a344ea1c\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomerServices.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Contents/Main/Customers/ServiceAndDocuments/CustomerServices.vue
// module id = 643
// module chunks = 1